import { render, staticRenderFns } from "./eod-measurement-text.vue?vue&type=template&id=0e8e19da&scoped=true"
import script from "./eod-measurement-text.vue?vue&type=script&lang=js"
export * from "./eod-measurement-text.vue?vue&type=script&lang=js"
import style0 from "./eod-measurement-text.vue?vue&type=style&index=0&id=0e8e19da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8e19da",
  null
  
)

export default component.exports